var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 275,
    height: 253,
    viewBox: "0 0 275 253",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M240.409 190.925L137.911 223.203L35.4473 190.925L137.911 153.817L240.409 190.925Z",
    fill: "#41B073"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M123.741 94.29V132.431L30 166.408V128.3L123.741 94.29Z",
    fill: "#1F305A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M123.741 30V66.0424L30 100.019V63.9771L123.741 30Z",
    fill: "#1F305A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M245.823 128.3V166.408L152.081 132.431V94.29L245.823 128.3Z",
    fill: "#1F305A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M245.823 63.9771V100.019L152.081 66.0424V30L245.823 63.9771Z",
    fill: "#1F305A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIcon);
export default __webpack_public_path__ + "static/media/logo-icon.d84332966738b54700fdb6eaefb4bea5.svg";
export { ForwardRef as ReactComponent };